import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import RoleOverview from './RoleOverview';
import './../SidePanelTabs.css';

export default function RoleTab(props) {
    const overviewTab = "overview";
    const [activeTab, setActiveTab] = useState("");

    useEffect(() => {
        if (props?.role) {
            setActiveTab(overviewTab);
        }
    }, [overviewTab, props]);

    function handleTabSelection(tab) {
        // Avoid excess reassignment
        if (tab !== activeTab) {
            setActiveTab(tab);
        }
    }

    function retrieveContent() {
        switch (activeTab) {
            case overviewTab:
                return (<RoleOverview role={props.role} companyNumber={props.companyNumber}/>);
            default:
                return (<LoadingSpinner blue data-testid="efup-tabs-loading-spinner" />);
        }
    }

    return (
        <React.Fragment>
            <div className="efup-tab-component" data-testid="efup-tabs-component">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === overviewTab ? "active" : ""}`}
                            id="overview-tab"
                            type="button"
                            onClick={() => handleTabSelection(overviewTab)}
                            data-testid="efup-overview-tab"
                        >
                            Overview
                        </button>
                    </li>
                </ul>
            </div>
            <div className="offcanvas-body">
                <div className="d-lg-block">
                    <div className="tab-content" id="myTabContent">
                        {retrieveContent()}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}